import { Button } from '@chakra-ui/react';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import BackIcon from '@/assets/icons/ic-arrow.svg';

import { SignUpContext, SignUpSteps } from '@/containers/SignUp/components/SignUpContext';

export const PreviousStep = () => {
  const { currentStep, setCurrentStep } = useContext(SignUpContext);
  const { t } = useTranslation();

  if (currentStep === SignUpSteps.BASIC_INFO || currentStep === SignUpSteps.FINISH) return null;

  return (
    <Button
      leftIcon={<BackIcon css={{ transform: 'rotate(180deg)' }} />}
      variant="ghost"
      colorScheme="black"
      onClick={() => setCurrentStep((s) => s - 1)}
    >
      {t('action.back')}
    </Button>
  );
};
